module.exports = __webpack_public_path__ + "media/images/arrows/prev-532f3ce15b01e1d60062f5cf847d89fa.png";